/**
 * @copyright 2020 Emden Consulting GmbH
 * @created 2020-09-01
 * @author Tim Lange <tl@systl.de>
 */

import { Environment } from 'models/box.model';
import { FB_PROJECT_ID } from 'config/env';

export const getEnvironment = (): Environment => {
  if (FB_PROJECT_ID) {
    if (FB_PROJECT_ID.includes('dev')) {
      return 'dev';
    } else if (FB_PROJECT_ID.includes('stage')) {
      return 'stage';
    }
  }

  return 'prod';
};
